import { render, staticRenderFns } from "./PythonExecutionArea.vue?vue&type=template&id=bffc8e7e"
import script from "./PythonExecutionArea.vue?vue&type=script&lang=ts"
export * from "./PythonExecutionArea.vue?vue&type=script&lang=ts"
import style0 from "./PythonExecutionArea.vue?vue&type=style&index=0&id=bffc8e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports